import * as actionTypes from './redux.actionTypes';

const initialState = {
    menus: [],
    permissions: [],
    selectedMenu: null,
    loading: false,
    permissionsLoading: false,
    error: null,
    total: 0,
    isMenuDialogOpen: false,
    isDeleteDialogOpen: false,
    menuToDelete: null
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        // Fetch menus
        case actionTypes.FETCH_MENUS:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actionTypes.FETCH_MENUS_SUCCESS:
            return {
                ...state,
                loading: false,
                menus: payload.data || [],
                total: payload.total || 0,
                error: null
            };

        case actionTypes.FETCH_MENUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        // Fetch menu by ID
        case actionTypes.FETCH_MENU_BY_ID:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actionTypes.FETCH_MENU_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedMenu: payload,
                error: null
            };

        case actionTypes.FETCH_MENU_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        // Create menu
        case actionTypes.CREATE_MENU:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actionTypes.CREATE_MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                menus: [...state.menus, payload],
                total: state.total + 1,
                isMenuDialogOpen: false,
                error: null
            };

        case actionTypes.CREATE_MENU_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        // Update menu
        case actionTypes.UPDATE_MENU:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actionTypes.UPDATE_MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                menus: state.menus.map((menu) =>
                    menu.menuId === payload.menuId ? payload : menu
                ),
                isMenuDialogOpen: false,
                selectedMenu: null,
                error: null
            };

        case actionTypes.UPDATE_MENU_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        // Delete menu
        case actionTypes.DELETE_MENU:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actionTypes.DELETE_MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                menus: state.menus.filter((menu) => menu.menuId !== payload.menuId),
                total: state.total - 1,
                isDeleteDialogOpen: false,
                menuToDelete: null,
                error: null
            };

        case actionTypes.DELETE_MENU_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        // Fetch permissions
        case actionTypes.FETCH_PERMISSIONS:
            return {
                ...state,
                permissionsLoading: true,
                error: null
            };

        case actionTypes.FETCH_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissionsLoading: false,
                permissions: payload.data || [],
                error: null
            };

        case actionTypes.FETCH_PERMISSIONS_FAILURE:
            return {
                ...state,
                permissionsLoading: false,
                error: payload
            };

        // UI actions
        case actionTypes.OPEN_MENU_DIALOG:
            return {
                ...state,
                isMenuDialogOpen: true,
                selectedMenu: payload
            };

        case actionTypes.CLOSE_MENU_DIALOG:
            return {
                ...state,
                isMenuDialogOpen: false,
                selectedMenu: null
            };

        case actionTypes.OPEN_DELETE_DIALOG:
            return {
                ...state,
                isDeleteDialogOpen: true,
                menuToDelete: payload
            };

        case actionTypes.CLOSE_DELETE_DIALOG:
            return {
                ...state,
                isDeleteDialogOpen: false,
                menuToDelete: null
            };

        case actionTypes.SET_SELECTED_MENU:
            return {
                ...state,
                selectedMenu: payload
            };

        case actionTypes.CLEAR_SELECTED_MENU:
            return {
                ...state,
                selectedMenu: null
            };

        default:
            return state;
    }
};
